// 用戶反饋列表組件
export default {
  // 頁面標題
  title: "用戶反饋列表",

  // 搜索和篩選
  usernamePlaceholder: "請輸入用戶名稱",
  selectTypePlaceholder: "請選擇類型",
  reset: "重置",
  search: "查詢",

  // 統計和加載
  totalRecords: "共計",
  records: "條數據",
  loading: "拼命加載中",

  // 表格列名
  username: "用戶名稱",
  phoneNumber: "手機號",
  email: "郵箱",
  type: "類型",
  content: "內容",
  createTime: "創建時間",
  remark: "備註",
  view: "查看",

  // 操作
  detail: "詳情",

  // 反饋類型
  all: "全部",
  problemFeedback: "問題反饋",
  featureSuggestion: "功能建議",
  caseAssistance: "案情協助",

  // 備註
  addRemark: "點擊添加備註",
  remarkSuccess: "修改備註成功",

  // 詳情字段
  userId: "用戶ID：",
  contactInfo: "聯繫方式：",
  emailLabel: "郵箱：",
  createTimeLabel: "創建時間：",
  contentLabel: "內容：",
};
